export default __webpack_public_path__ + "static/car2-e25d75a92dd4c1749b9f8225c6af8dbc.glb";